import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';

export default function MissingArticleItem() {
  return (
    <Box className="relative m-10 mt-0 p-16 border rounded-8 bg-gray-50">
      <div className="flex items-center gap-8">
        <FuseSvgIcon size={20} color="disabled">heroicons-outline:document-text</FuseSvgIcon>
        <Typography variant="body2" color="textSecondary">
          This article is no longer available
        </Typography>
      </div>
    </Box>
  );
}